import { MyQueuePage, AuditQueuePage, IgStoryLanding, SaAssignmentDetailPage } from 'domains/sales/ig-story/queue-access'
import { withSalesUsersAccess } from 'domains/sales/users/components/sales-users-access-guard'
import React from 'react'
// import {
//   SalesAppointmentsCreatePage,
//   SalesAppointmentsDetailPage,
//   SalesAppointmentsListPage
// } from 'domains/sales/appointments'
import { SalesDealsBkoCreatePage, SalesDealsCreatePage } from 'domains/sales/deals'
import { SalesDealsListPage } from 'domains/sales/deals/pages'
import { SalesDealsDetailPage } from 'domains/sales/deals/pages'
import { SalesShipmentListPage } from 'domains/sales/deals/pages'
import { ConsignorSentListPage } from 'domains/revenue/consignor/pages/sent-list-page'
import { SalesIgStoryDetailPage } from 'domains/sales/ig-story'
import Phase3CreateIntakePage from 'domains/phase3-inbound-journey/pages/Phase3CreateIntakePage'

import {
  SalesUsersListPage,
  SalesUsersCreatePage,
  SalesUsersDetailPage,
} from 'domains/sales/users/pages'

import MigrationResourcePage from 'domains/dashboard-migration/resource-page'
import LegacyAppraisalsPage from 'domains/dashboard-migration/appraisals-page'

const sales_team_routes = {
  collapse  : true,
  path      : '/sales',
  name      : 'Sales Team',
  icon      : 'fas fa-cart-arrow-down text-blue',
  state_key : 'sales_team_collapse',
  views     : [
    {
      path: '/sales/user-histories',
      name: 'User Histories',
      miniName: 'UH',
      allowedRoles: [ 'owner', 'admin', 'sales', 'web', 'marketing', 'finance' ],
      component: (props) => <MigrationResourcePage { ...props } resourceKey='user_histories' archive />,
      layout: '/app'
    },
    {
      path: '/sales/legacy-appraisals',
      name: 'Legacy Appraisals',
      miniName: 'LA',
      allowedRoles: [ 'owner', 'admin', 'sales', 'web', 'stc', 'customer service' ],
      component: LegacyAppraisalsPage,
      layout: '/app'
    },

    // ========= Inbound Journey =========
    {
      collapse  : true,
      name      : 'Inbound Journey',
      miniName  : 'IJ',
      state_key : 'sales_team_inbound_journey_collapse',
      views     : [
        {
          path      : '/sales/inbound-journey/create-intake',
          name      : 'Create Consign',
          miniName  : 'CC',
          component : (props) => <Phase3CreateIntakePage { ...props } apiNamespace='sales' />,
          layout    : '/app'
        }
      ]
    },

    // ========= IG Story =========
    {
      collapse  : true,
      name      : 'IG Story',
      miniName  : 'IG',
      state_key : 'sales_ig_story_collapse',
      views     : [
        { path: '/sales/ig-story/my-queue', name: 'My Queue', miniName: 'MQ',
          component: MyQueuePage, layout: '/app', allowedRoles: ['sales', 'owner', 'admin'] },
        { path: '/sales/ig-story/audit-queue', name: 'Audit Queue', miniName: 'AQ',
          component: AuditQueuePage, layout: '/app', allowedRoles: ['owner', 'admin'], allowedEmails: ['angel@belleandkate.com'] }
      ]
    },
    {
      path: '/sales/ig-story', component: IgStoryLanding, layout: '/app', invisible: true
    },
    {
      path         : '/sales/ig-story/sa/:administratorId/assignments',
      name         : 'SA Assignment Detail',
      miniName     : 'IG',
      component    : SaAssignmentDetailPage,
      layout       : '/app',
      invisible    : true,
      allowedRoles : ['owner', 'admin'],
      allowedEmails: ['angel@belleandkate.com']
    },
    {
      path      : '/sales/ig-story/:id',
      name      : 'IG Story Detail',
      miniName  : 'IG',
      component : SalesIgStoryDetailPage,
      layout    : '/app',
      invisible : true
    },

    // ========= Users =========
    {
      path      : '/sales/users',
      name      : 'User List',
      miniName  : 'U',
      component : withSalesUsersAccess(SalesUsersListPage, 'read'),
      layout    : '/app'
    },
    {
      path      : '/sales/users/create',
      name      : 'Create User',
      miniName  : 'U',
      component : withSalesUsersAccess(SalesUsersCreatePage, 'create'),
      layout    : '/app',
      invisible : true
    },
    {
      path      : '/sales/users/:id',
      name      : 'Detail User',
      miniName  : 'U',
      component : withSalesUsersAccess(SalesUsersDetailPage, 'read'),
      layout    : '/app',
      invisible : true
    },

     // ========= Deals =========
    {
      path      : '/sales/deals/create',
      name      : 'Create Deal Ready',
      miniName  : 'D',
      component : SalesDealsCreatePage,
      layout    : '/app'
    },
    {
      path      : '/sales/deals/create-bko',
      name      : 'Create Deal BKO (PO)',
      miniName  : 'BKO',
      component : SalesDealsBkoCreatePage,
      layout    : '/app'
    },
    {
      path      : '/sales/deals/',
      name      : 'Deal List',
      miniName  : 'D',
      component : SalesDealsListPage,
      layout    : '/app'
    },
    {
      path      : '/sales/deals?scope=ready_to_ship',
      name      : 'Shipment List',
      miniName  : 'L',
      component : SalesShipmentListPage,
      layout    : '/app'
    },
    {
      path      : '/sales/deals/:id',
      name      : 'Deal Detail',
      miniName  : 'D',
      component : SalesDealsDetailPage,
      layout    : '/app',
      invisible : true
    },
    {
      path      : '/sales/consignor/confirm-transfer',
      name      : 'Confirm Transfer',
      miniName  : 'CT',
      component : ConsignorSentListPage,
      layout    : '/app',
      invisible : true
    },
    // {
    //   path      : '/sales/appointment/create',
    //   name      : 'Create Appointment',
    //   miniName  : 'C',
    //   component : SalesAppointmentsCreatePage,
    //   layout    : '/app'
    // },
    // {
    //   path      : '/sales/appointment/list',
    //   name      : 'Appointments List',
    //   miniName  : 'L',
    //   component : SalesAppointmentsListPage,
    //   layout    : '/app'
    // },
    // {
    //   path      : '/sales/appointments/:id',
    //   name      : 'Sales Appointment Detail',
    //   miniName  : 'SlsApp',
    //   component : SalesAppointmentsDetailPage,
    //   layout    : '/app',
    //   invisible : true
    // }
  ]
}

export default sales_team_routes
